import axios from "axios";

import {
  API_ADMIN_GROUPS,
  API_ADMIN_USERS,
  API_ADMIN_ROLES,
  API_ADMIN_ROBOTS,
  API_USERS_ROBOTS,
} from "../../libs/constants";

import { getToken } from "../../libs/auth";

// ##############################
// Admin
// ##############################
export async function getGroups() {
  const url = `${API_ADMIN_GROUPS}`;

  const options = {
    method: "get",
    headers: { Authorization: `bearer ${getToken()}` },
    url,
  };

  try {
    const { data, status } = await axios(options);

    if (status === 200) {
      return data;
    } else {
      throw new Error(status);
    }
  } catch (err) {
    throw err;
  }
}

export async function newGroup(payload) {
  const url = `${API_ADMIN_GROUPS}`;

  const options = {
    method: "post",
    headers: { Authorization: `bearer ${getToken()}` },
    url,
    data: { ...payload },
  };

  try {
    const { data, status } = await axios(options);

    if (status === 200) {
      return data;
    } else {
      throw new Error(status);
    }
  } catch (err) {
    throw err;
  }
}

export async function editGroupResource(id, payload) {
  const url = `${API_ADMIN_GROUPS}/${id}/resource`;

  const options = {
    method: "put",
    headers: { Authorization: `bearer ${getToken()}` },
    url,
    data: { ...payload },
  };

  try {
    const { data, status } = await axios(options);

    if (status === 200) {
      return data;
    } else {
      throw new Error(status);
    }
  } catch (err) {
    throw err;
  }
}

export async function newTier(params) {
  const url = `${API_USERS_ROBOTS}/${params}/bandwidth`;

  const options = {
    method: "post",
    headers: { Authorization: `bearer ${getToken()}` },
    url,
  };
  try {
    const { data, status } = await axios(options);

    if (status === 200) {
      return data;
    } else {
      throw new Error(status);
    }
  } catch (err) {
    throw err;
  }
}

export async function updateUsage(params, payload) {
  const url = `${API_USERS_ROBOTS}/${params}/bandwidth`;

  const options = {
    method: "put",
    headers: { Authorization: `bearer ${getToken()}` },
    url,
    data: payload,
  };
  try {
    const { data, status } = await axios(options);

    if (status === 200) {
      return data;
    } else {
      throw new Error(status);
    }
  } catch (err) {
    throw err;
  }
}

export async function getRobots() {
  const url = `${API_ADMIN_ROBOTS}`;

  const options = {
    method: "get",
    headers: { Authorization: `bearer ${getToken()}` },
    url,
  };

  try {
    const { data, status } = await axios(options);

    if (status === 200) {
      return data;
    } else {
      throw new Error(status);
    }
  } catch (err) {
    throw err;
  }
}

export async function getUsers() {
  const url = `${API_ADMIN_USERS}`;

  const options = {
    method: "get",
    headers: { Authorization: `bearer ${getToken()}` },
    url,
  };

  try {
    const { data, status } = await axios(options);

    if (status === 200) {
      return data;
    } else {
      throw new Error(status);
    }
  } catch (err) {
    throw err;
  }
}

export async function getRoles() {
  const url = `${API_ADMIN_ROLES}`;

  const options = {
    method: "get",
    headers: { Authorization: `bearer ${getToken()}` },
    url,
  };

  try {
    const { data, status } = await axios(options);

    if (status === 200) {
      return data;
    } else {
      throw new Error(status);
    }
  } catch (err) {
    throw err;
  }
}

export async function editRoleResource(id, payload) {
  const url = `${API_ADMIN_USERS}/role`;

  console.log("sr", url, payload);

  const options = {
    method: "put",
    headers: { Authorization: `bearer ${getToken()}` },
    url,
    data: { ...payload },
  };

  try {
    const { data, status } = await axios(options);

    if (status === 200) {
      return data;
    } else {
      throw new Error(status);
    }
  } catch (err) {
    throw err;
  }
}
